import {Link, Navigate, useLocation, useNavigate} from "react-router-dom";
import {CSSProperties, ReactNode} from "react";
import React from "react";
import {StylesProps} from "react-select/dist/declarations/src/styles";

export const useNavigateWithParams = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (path: string) => {
    navigate(path + location.search);
  };
}

type LinkWithParamsProps = {
  to: string,
  children: ReactNode,
  className?: string,
  style?: CSSProperties,
}

/**
 * A version of Link that keeps the url query params.
 */
export const LinkWithParams = (props: LinkWithParamsProps) => {

  const location = useLocation();
  
  return <Link className={props.className} style={props.style}
               to={`${props.to}${location.search}`}>
    {props.children}
  </Link>
}

/**
 * A version of Navigate that keeps the url query params.
 */
export const NavigateWithParams = (props: {to: string}) => {
  const location = useLocation();
  return <Navigate to={`${props.to}${location.search}`}/>
}